import { gql, TypedDocumentNode } from '@apollo/client'
import { getApolloClient } from '@vivaldis/common'
import { SuMissingCertificateReminderInput } from '../../../../../typings/__generated__'
import type {
  SuMissingCertificateReminder,
  SuMissingCertificateReminderVariables
} from './__generated__/SuMissingCertificateReminder'

const suMissingCertificateReminderMutation: TypedDocumentNode<
  SuMissingCertificateReminder,
  SuMissingCertificateReminderVariables
> = gql`
  mutation SuMissingCertificateReminder(
    $input: SuMissingCertificateReminderInput!
  ) {
    suMissingCertificateReminder(input: $input) {
      status
    }
  }
`

export const suMissingCertificateReminder = (
  input: SuMissingCertificateReminderInput
) => {
  const apolloClient = getApolloClient()
  return apolloClient.mutate({
    mutation: suMissingCertificateReminderMutation,
    variables: {
      input: input
    }
  })
}
